import { render, staticRenderFns } from "./BusinessFlightsComponent.vue?vue&type=template&id=0ba536b4"
import script from "./BusinessFlightsComponent.vue?vue&type=script&lang=js"
export * from "./BusinessFlightsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports